module.exports = __webpack_public_path__ + "static/media/5.3ef78cc2.png";